import { render, staticRenderFns } from "./ResourceForm.vue?vue&type=template&id=186b9fd8&scoped=true"
import script from "./ResourceForm.vue?vue&type=script&lang=js"
export * from "./ResourceForm.vue?vue&type=script&lang=js"
import style0 from "./ResourceForm.vue?vue&type=style&index=0&id=186b9fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b9fd8",
  null
  
)

export default component.exports